export enum ContractRequestStatusLabel {
    Open = 'Open',
    Pending = 'Pending',
    Recalled = 'Recalled',
    Assigned = 'Assigned',
    NeedsInfo = 'Needs Info',
    Rejected = 'Rejected',
    Drafting = 'Drafting',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}
